// extracted by mini-css-extract-plugin
export var box = "_41-2";
export var checkboxControl = "_41-0";
export var checkboxRow = "_41-9";
export var checked = "_41-3";
export var descriptionSpacer = "_41-b";
export var disabled = "_41-4";
export var icon = "_41-7";
export var input = "_41-1";
export var labelSpacer = "_41-a";
export var medium = "_41-6";
export var small = "_41-5";
export var text = "_41-8";